.content{margin:0;color:var(--color-fg-secondary);font-size:14px;line-height:1.6}
/*# sourceMappingURL=info-popup-YYESWL36.css.map */
